import {
  ADD_INTERVIEWER,
  ADD_INTERVIEWER_ERROR,
  ADD_INTERVIEWER_SUCCESS,
  GEN_OFFER_LETTER, GEN_OFFER_LETTER_FAILURE, GEN_OFFER_LETTER_SUCCESS,
  GET_EDIT_GEN_OFFER_LETTER_DETAILS,
  GET_EDIT_GEN_OFFER_LETTER_DETAILS_FAIL,
  GET_EDIT_GEN_OFFER_LETTER_DETAILS_SUCCESS,
  GET_GEN_OFFER_LETTER_DETAIL,
  GET_GEN_OFFER_LETTER_DETAIL_FAILURE,
  GET_GEN_OFFER_LETTER_DETAIL_SUCCESS,
  GET_HIRE_CANDIDATE,
  GET_HIRE_CANDIDATE_FAILURE,
  GET_HIRE_CANDIDATE_SUCCESS,
  GET_INTERVIEWERS,
  GET_INTERVIEWERS_ERROR,
  GET_INTERVIEWERS_SUCCESS,
  GET_INTERVIEW_ROUNDS,
  GET_INTERVIEW_ROUNDS_FAILURE,
  GET_INTERVIEW_ROUNDS_SUCCESS,
  HIRENEURON_VIDEO_INTEGRATION, HIRENEURON_VIDEO_INTEGRATION_FAIL, HIRENEURON_VIDEO_INTEGRATION_SUCCESS,
  OFFER_LETTER_TYPE,
  OFFER_LETTER_TYPE_FAILURE,
  OFFER_LETTER_TYPE_SUCCESS,
  POST_INTERVIEW_DETAILS,
  POST_INTERVIEW_DETAILS_ERROR,
  POST_INTERVIEW_DETAILS_SUCCESS,
  RESCHEDULE_INTERVIEW,
  RESCHEDULE_INTERVIEW_FAILURE,
  RESCHEDULE_INTERVIEW_SUCCESS,
  SAVE_HIRE_CANDIDATE_DATA,
  SAVE_HIRE_CANDIDATE_DATA_FAILURE,
  SAVE_HIRE_CANDIDATE_DATA_SUCCESS,
  VIDEO_INTERVIEW
} from "./actionTypes"


const initialState = {
    scheduleLoading: false,
    interviewers:null,
    interviewersSuccess:null,
    interviewersError:null,
    scheduleInterviewSuccess:null,
    scheduleInterviewError:null,
    addInterviewerSuccess:null,
    addInterviewerError:null,
    rescheduleInterviewSuccess:null,
    rescheduleInterviewFailure:null,
    interviewRoundsError:null,
    interviewRoundsSuccess:null,
    hireCandidateData:null,
    hireCandidateError:null,
    saveHireCandidateDataSuccess:null,
    saveHireCandidateSuccessData:null,
    rejectCandidateData:null,
    rejectCandidateError:null,
    templateLetterTypeList:null,
    templateLetterTypeError:null,
    offerLetterDetail:null,
    offerLetterDetailError:null,
    videoInterviewCode: null,
    addInterviewRondData: null,
    errorAddInterviewRondData: null,
    tokenError:null,
    tokenSuccess:null,
    loading:false,
    revokeOffer: null,
    revokeOffererror: null,
  }



const scheduleInterviewReducer = (state = initialState, action) => {
    switch (action.type) {
        
      case GET_INTERVIEWERS:
        state = {
          ...state,
          scheduleLoading: true,
          interviewers:null,
          scheduleInterviewError:null,
          scheduleInterviewSuccess:null,
          addInterviewerSuccess:null,
          addInterviewerError:null,
          rescheduleInterviewSuccess:null,
          rescheduleInterviewFailure:null,
          addInterviewRondData: null,
        }
        break
      case GET_INTERVIEWERS_SUCCESS:
        state = {
          ...state,
          scheduleLoading: false,
          interviewers: action.payload,
          scheduleInterviewError:null,
          scheduleInterviewSuccess:null,
          addInterviewerSuccess:null,
          addInterviewerError:null
      
        }
        break
      case GET_INTERVIEWERS_ERROR:
        state = {
          ...state,
          scheduleLoading: false,
          interviewers:null,
          interviewersError:action.payload,
          scheduleInterviewSuccess:null,
          addInterviewerSuccess:null,
          addInterviewerError:null,
          rescheduleInterviewSuccess:null,
          rescheduleInterviewFailure:null,
      
        }
        break
        case POST_INTERVIEW_DETAILS:
          state = {
            ...state,
            scheduleLoading: true,
            scheduleInterviewSuccess:null,
            scheduleInterviewError:null

          }
          break
          case POST_INTERVIEW_DETAILS_SUCCESS:
       
            state = {
              ...state,
              scheduleLoading: false,
              scheduleInterviewSuccess:action.payload,
              scheduleInterviewError:null
  
            }
            break

            case VIDEO_INTERVIEW:
            state = {
              ...state,
              scheduleLoading: false,
              videoInterviewCode: action.payload
            }
            break

            case POST_INTERVIEW_DETAILS_ERROR:
       
            state = {
              ...state,
              scheduleLoading: false,
              scheduleInterviewError:action.payload,
              scheduleInterviewSuccess:null
  
            }
            break
            case ADD_INTERVIEWER:
              state={
                ...state,
                scheduleLoading:true,
                addInterviewerLoader:true,
                addInterviewerSuccess:null,
                addInterviewerError:null
              }
            break  
            case ADD_INTERVIEWER_SUCCESS:
              state={
                ...state,
                scheduleLoading:false,
                addInterviewerLoader:false,
                addInterviewerSuccess:action.payload,
                addInterviewerError:null
              }
            break 
            case ADD_INTERVIEWER_ERROR:
              state={
                ...state,
                scheduleLoading:false,
                addInterviewerLoader:false,
                addInterviewerSuccess:null,
                addInterviewerError:action.payload,
              }
            break   
            case RESCHEDULE_INTERVIEW:
              state={
                ...state,
                scheduleLoading:true,
                rescheduleInterviewSuccess:null,
                rescheduleInterviewFailure:null,
              }
            break   
            case RESCHEDULE_INTERVIEW_SUCCESS:
              
              state={
                ...state,
                scheduleLoading:false,
                rescheduleInterviewSuccess:action.payload,
                rescheduleInterviewFailure:null,
              }
            break   
            case RESCHEDULE_INTERVIEW_FAILURE:
             
              state={
                ...state,
                scheduleLoading:false,
                rescheduleInterviewSuccess:null,
                rescheduleInterviewFailure:action.payload,
              }
            break   
            case GET_INTERVIEW_ROUNDS:
              state={
                ...state,
                scheduleLoading:true,
                interviewRoundsSuccess:null,
                interviewRoundsError:null,
              }
            break   
            case GET_INTERVIEW_ROUNDS_SUCCESS:
              
              state={
                ...state,
                scheduleLoading:false,
                interviewRoundsSuccess:action.payload,
                interviewRoundsError:null,
              }
            break   
            case GET_INTERVIEW_ROUNDS_FAILURE:
             
              state={
                ...state,
                scheduleLoading:false,
                interviewRoundsSuccess:null,
                interviewRoundsError:action.payload,
              }
            break  
            case SAVE_HIRE_CANDIDATE_DATA:
              state={
                ...state,
                scheduleLoading:true,
                saveHireCandidateSuccessData:null,
                saveHireCandidateDataError:null,
              }
            break   
            case SAVE_HIRE_CANDIDATE_DATA_SUCCESS:
              
              state={
                ...state,
                scheduleLoading:false,
                saveHireCandidateSuccessData:action.payload,
                saveHireCandidateDataError:null,
              }
            break   
            case SAVE_HIRE_CANDIDATE_DATA_FAILURE:
             
              state={
                ...state,
                scheduleLoading:false,
                saveHireCandidateSuccessData:null,
                saveHireCandidateDataError:action.payload,
              }
            break  
            case GET_HIRE_CANDIDATE:
              state={
                ...state,
                scheduleLoading:true,
                hireCandidateData:null,
                hireCandidateError:null,
              }
            break   
            case GET_HIRE_CANDIDATE_SUCCESS:
              
              state={
                ...state,
                scheduleLoading:false,
                hireCandidateData:action.payload,
                hireCandidateError:null,
              }
            break   
            case GET_HIRE_CANDIDATE_FAILURE:
             
              state={
                ...state,
                scheduleLoading:false,
                hireCandidateData:null,
                hireCandidateError:action.payload,
              }
            break  
            case OFFER_LETTER_TYPE:
              state={
                ...state,
                scheduleLoading:true,
                templateLetterTypeList:null,
                templateLetterTypeError:null,
              }
            break   
            case OFFER_LETTER_TYPE_FAILURE:
              
              state={
                ...state,
                scheduleLoading:false,
                templateLetterTypeError:action.payload,
                templateLetterTypeList:null,
              }
            break   
            case OFFER_LETTER_TYPE_SUCCESS:
             
              state={
                ...state,
                scheduleLoading:false,
                templateLetterTypeError:null,
                templateLetterTypeList:action.payload,
              }
            break  
            case GEN_OFFER_LETTER:
              state={
                ...state,
                scheduleLoading:true,
                genLetterSuccess:null,
                genLetterError:null,
              }
            break   
            case GEN_OFFER_LETTER_FAILURE:
              
              state={
                ...state,
                scheduleLoading:false,
                genLetterError:action.payload,
                 genLetterSuccess:null,
              }
            break   
            case GEN_OFFER_LETTER_SUCCESS:
             
              state={
                ...state,
                scheduleLoading:false,
                genLetterError:null,
                genLetterSuccess:action.payload,
              }
            break  
            case GET_GEN_OFFER_LETTER_DETAIL:
              state={
                ...state,
                scheduleLoading:true,
                offerLetterDetail:null,
                offerLetterError:null,
              }
            break   
            case GET_GEN_OFFER_LETTER_DETAIL_FAILURE:
              
              state={
                ...state,
                scheduleLoading:false,
                offerLetterError:action.payload,
                offerLetterDetail:null,
              }
            break   
            case GET_GEN_OFFER_LETTER_DETAIL_SUCCESS:
             
              state={
                ...state,
                scheduleLoading:false,
                offerLetterError:null,
                offerLetterDetail:action.payload,
              }
            break
            case HIRENEURON_VIDEO_INTEGRATION:
              state={
                ...state,
                loading:true,
                tokenSuccess:null,
                tokenError:null,
              }
            break   
            case HIRENEURON_VIDEO_INTEGRATION_FAIL:
              
              state={
                ...state,
                loading:false,
                tokenError:action.payload,
                tokenSuccess:null,
              }
            break   
            case HIRENEURON_VIDEO_INTEGRATION_SUCCESS:
             
              state={
                ...state,
                loading:false,
                tokenError:null,
                tokenSuccess:action.payload,
              }
            break  

            case GET_EDIT_GEN_OFFER_LETTER_DETAILS:
            state={
              ...state,
              loading:true,
              revokeOffer: null,
              revokeOffererror: null,
            }
          break
          case GET_EDIT_GEN_OFFER_LETTER_DETAILS_SUCCESS:
            state={
              ...state,
              loading:false,
              revokeOffer: action.payload,
              revokeOffererror: null,
            }
          break    
          case GET_EDIT_GEN_OFFER_LETTER_DETAILS_FAIL:
            state={
              ...state,
              loading:false,
              revokeOffer: null,
              revokeOffererror: action.payload,
            }
          break 

      default:
        state = { ...state }
        break
    }
    return state
  }
  
  export default scheduleInterviewReducer
  